import { createFileRoute } from "@tanstack/react-router";
import CuttingProcessView from "@/components/views/CuttingProcess/cutting-process.view";

export const Route = createFileRoute("/generate")({
    component: RouteComponent,
});

function RouteComponent() {
    return <CuttingProcessView data-testid="home-page" />;
}
